import { useTheme } from "@mui/material";

interface SvgIconProps {
    progress: number;
    standardWidth:string,
    icon:string
   
  }
export function IconAutoplay({ progress,standardWidth,icon }:SvgIconProps){
  const theme = useTheme();
  //onst viewBox = "0 "+"0 "+standardWidth+" "+standardWidth;
  
  switch (icon) {
  case "arrowRight":
    return(
      <svg width={ standardWidth } height={ standardWidth } viewBox="0 0 17.3 21.6" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="linearGradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset={ `${progress}%` } stopColor={ theme.customColors.textPrimaryCta } />
            <stop offset={ `${progress}%` } stopColor={ theme.customColors.backgroundPrimaryCta } />
          </linearGradient>
        </defs>
        <path d="M2.6,21.6c-0.4,0-0.9-0.1-1.2-0.3C0.5,20.8,0,19.9,0,18.9L0,2.7c0-1,0.6-2,1.6-2.4c1-0.4,2.1-0.3,2.9,0.4 l11.8,7.7c0.7,0.6,1.1,1.3,1.1,2.2c0,0.9-0.4,1.6-1.1,2.1l-8.4,5.9l-0.6-0.8l8.5-5.9c0.4-0.3,0.7-0.8,0.7-1.3c0-0.5-0.2-1-0.6-1.4L3.8,1.5C3.3,1,2.6,0.9,2,1.2C1.4,1.5,1,2,1,2.7v7.6L1,18.9c0,0.6,0.3,1.2,0.9,1.5c0.6,0.3,1.2,0.3,1.7-0.1l0.6,0.8C3.7,21.4,3.2,21.6,2.6,21.6z"
          fill="url(#linearGradient)"
          stroke="url(#strokeGradient)"
          strokeWidth="2"/>
      </svg>
    );
  default:
    return null;
  }
}
